declare const window: any;
declare const require: any;

import "babel-polyfill";
// use Bluebird, not any other promise library
window.Promise = require("bluebird");

const environments = require("../environments");
const { loadScripts } = require("./third-party-scripts");

import { configure, runInAction } from "mobx";
import { telemetry, SeverityLevel } from "./lib/telemetry";
import { config } from "./lib/utils/config";
import { hasConsent } from "./lib/utils/cookie-consent";
import { FetchError } from "./lib/http/fetch-error";
import * as smoothscroll from "smoothscroll-polyfill";
import { templateSettings } from "lodash";

import "inert-polyfill";
import "url-polyfill";
import "raf";

smoothscroll.polyfill();
const ENV = config.getEnv();

// Expose this to TestCafe if it needs to screw around with observables (currently does for forcing feature flags)
window.__runInAction__ = runInAction;

// Track unhandled promise rejections in Application Insights
// Bugsnag does this automatically
Promise.onPossiblyUnhandledRejection((reason) => {
  telemetry.trackException(reason instanceof FetchError ? reason.toJs : reason, undefined, SeverityLevel.Error);
});

/**
 * Promise configuration. Enable cancellation. This will allow us to call `cancel()`
 * on any promise.
 */
Promise.config({
  cancellation: true
});

/**
 * Switching on `strict` mode for MobX. This will force us to use the
 * `@action` decorator to explicitly mark functions which change application state.
 */
if (ENV !== environments.PROD) {
  configure({ enforceActions: "observed" });
}

/**
 * Cookie consent configuration.
 */
const onConsent = () => {
  if (hasConsent()) {
    loadScripts();
    telemetry.init();
  }
};

if (window.mscc) {
  window.mscc.on("consent", onConsent);
  window.mscc.on("show", () => {
    document.body.setAttribute("consent-visible", "");
  });
  window.mscc.on("hide", () => {
    document.body.removeAttribute("consent-visible");
  });
  // since the mscc auto inits, we miss the key events.
  if (window.mscc.isVisible()) {
    document.body.setAttribute("consent-visible", "");
  }
  if (window.mscc.hasConsent()) {
    onConsent();
  }
} else {
  onConsent();
}

// Change lodash's template delimiters to {{ and }}
templateSettings.interpolate = /{{([\s\S]+?)}}/g;
